import * as React from 'react'
import { Button } from '@mobiscroll/react-latest'
import { OrganizationTeamMemberDisplayStatuses } from '../../../constants/organization-team-member-statuses'
import ArchiveIcon from '../../icons/ui/Archive'
import EntityHeaderTitle from '../../ui/entity/EntityHeaderTitle'
import { IStationUserSearchObject } from 'src/types/station-user'
import { handleRedirect } from 'src/utils'
import UIMessages from 'src/utils/ui-messages'
import Edit from 'src/components/icons/drivers/Edit'

interface IStationUserInfoHeader {
  activeTab: string
  isArchived?: boolean
  loading: boolean
  name: string
  status: string
  stationUser: IStationUserSearchObject
  onMoveToArchive: () => void
}

const StationUserInfoHeader = ({
  activeTab,
  isArchived,
  loading,
  name,
  stationUser,
  status,
  onMoveToArchive
}: IStationUserInfoHeader) => {
  const { active, archived, edit, moveToArchive, restoreFromArchive } = UIMessages.common
  const editPath =
    activeTab === 'User Info' ? `/station-user/edit/${stationUser.id}` : `/station-user/${stationUser.id}/zones/edit`

  const headerButtonMapping = [
    {
      ariaLabel: 'Edit button',
      btnLabel: edit,
      icon: <Edit className='absolute icon--small ml2 svg-fill-white-path z1' />,
      onClick: () => handleRedirect(editPath)
    },
    {
      ariaLabel: 'Archiving button',
      btnLabel: isArchived ? restoreFromArchive : moveToArchive,
      icon: <ArchiveIcon className='absolute icon--small ml2 svg-fill-white-path z1' />,
      onClick: onMoveToArchive
    }
  ]

  return (
    <div className='flex justify-between items-center p2'>
      <div>
        <EntityHeaderTitle>{name}</EntityHeaderTitle>
        <span className='h5 ml2'>
          {`Status: ${
            OrganizationTeamMemberDisplayStatuses[status as keyof typeof OrganizationTeamMemberDisplayStatuses]
          }
          | ${isArchived ? archived : active}`}
        </span>
      </div>
      <div className='flex'>
        {headerButtonMapping.map(({ ariaLabel, btnLabel, icon, onClick }) => (
          <div className='flex items-center relative' key={ariaLabel}>
            <Button
              ariaLabel={ariaLabel}
              className='mbsc-btn-with-start-icon mbsc-success-btn'
              disabled={loading}
              onClick={onClick}
            >
              {btnLabel}
            </Button>
            {icon}
          </div>
        ))}
      </div>
    </div>
  )
}

export default StationUserInfoHeader



// WEBPACK FOOTER //
// ./src/components/station-user/view/StationUserInfoHeader.tsx